import { EnumUnitUnits, EnumUnitDimension } from 'src/types/common/common';
export const unitStandard = {
  [EnumUnitUnits.inch]: 'inch',
  [EnumUnitUnits.foot]: 'foot',
  [EnumUnitUnits.yard]: 'yard',
  [EnumUnitUnits.mile]: 'mile',
  [EnumUnitUnits.metre]: 'm',
  [EnumUnitUnits.centimetre]: 'cm',
  [EnumUnitUnits.kilometre]: 'km',
  [EnumUnitUnits.millimetre]: 'mm',
  [EnumUnitDimension.ounces]: 'ounces',
  [EnumUnitDimension.pound]: 'pound',
  [EnumUnitDimension.milligram]: 'milligram',
  [EnumUnitDimension.gram]: 'g',
  [EnumUnitDimension.kilogram]: 'kg',
};

export const unitWeight = [
  {
    label: EnumUnitUnits.inch,
    value: EnumUnitUnits.inch,
  },
  {
    label: EnumUnitUnits.foot,
    value: EnumUnitUnits.foot,
  },
  {
    label: EnumUnitUnits.yard,
    value: EnumUnitUnits.yard,
  },
  {
    label: EnumUnitUnits.mile,
    value: EnumUnitUnits.mile,
  },
  {
    label: EnumUnitUnits.millimetre,
    value: EnumUnitUnits.millimetre,
  },
  {
    label: EnumUnitUnits.centimetre,
    value: EnumUnitUnits.centimetre,
  },
  {
    label: EnumUnitUnits.metre,
    value: EnumUnitUnits.metre,
  },
  {
    label: EnumUnitUnits.kilometre,
    value: EnumUnitUnits.kilometre,
  },
];

export const unitDimension = [
  {
    label: EnumUnitDimension.ounces,
    value: EnumUnitDimension.ounces,
  },
  {
    label: EnumUnitDimension.pound,
    value: EnumUnitDimension.pound,
  },
  {
    label: EnumUnitDimension.milligram,
    value: EnumUnitDimension.milligram,
  },
  {
    label: EnumUnitDimension.gram,
    value: EnumUnitDimension.gram,
  },
  {
    label: EnumUnitDimension.kilogram,
    value: EnumUnitDimension.kilogram,
  },
];
